import { useContext, useMemo } from "react";
import axios from "axios";
import config from "../Config";
import { LoginContext } from "../Auth/LoginContextProvider";

function useAPI() {
  const { loginToken } = useContext(LoginContext);
  let baseURL = config.api.baseUrl;
  const http = useMemo(
    () =>
      axios.create({
        baseURL: baseURL,
        headers: { Authorization: `Token ${loginToken}` },
      }),
    [loginToken, baseURL]
  );
  return http;
}

export default useAPI;
